import { Component, ojs, app } from "modular-openscriptjs";

const h = app("h");

export default class Container extends Component {
	render(...args) {
		return h._(h.div({ class: "container-xl" }, ...args));
	}
}
